"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyFaceAndPremium = void 0;
const emptyFaceAndPremium = () => ({ premium: undefined, faceAmount: undefined });
exports.emptyFaceAndPremium = emptyFaceAndPremium;
//# sourceMappingURL=models.js.map